// import moment from 'moment';
// import { upperFirst } from 'lodash';
import moment from 'moment';
import ApiService from './api.service';

// actions
export const GET_AWALIST = 'getAwaList';
export const GET_AWALIST_FINANCE = 'getAwaListFinance';
export const INQUIRY_APPROVAL = 'inquiryAwaApproval';
export const SUBMIT_APPROVAL = 'submitAwaApproval';
export const GET_DETAIL_AWALIST_FINANCE = 'getDetailAwaList';
export const GET_DETAIL_AWA_INSTALLMENT = 'getDetailAwaInstallment';
export const GET_ALL_DETAIL_AWALIST = 'getAllDetailAwaList';
export const ROLLBACK_APPROVAL = 'rollbackAwaApproval';
export const REJECT_AWA = 'rejectAwa';
export const INVOICE_LIST = 'getInvoiceAwaList';
export const INVOICE_GENERATE = 'generateNewAwaInvoice';
export const INVOICE_REGENERATE = 'regenerateAwaInvoice';
export const SETTLE_OVER_DUE_INVOICE = 'settleOverDueInvoice';
export const INVOICE_INQUIRY = 'inquiryNewAwaInvoice';
export const INVOICE_DETAIL_AWA = 'getInvoiceAwaDetail';
export const INVOICE_UPDATE_STATUS = 'updateInvoiceAwaStatus';
export const INVOICE_PARTIAL_UPDATE_STATUS = 'partialUpdateAwaInvoiceStatus';
export const CHECK_EWA_BALANCE = 'checkAwaBalance';
export const GET_EWA_WALLET_HISTORIES = 'getHistoriesAwaWallet';
export const DOWNLOAD_EWA_WALLET_HISTORIES = 'downloadHistoriesAwaWallet';
export const GET_AWA_REPORT = 'getAwaReport';

// mutations
export const SET_AWALIST = 'setAwaList';
export const SET_AWALIST_FINANCE = 'setAwaListFinance';
export const SET_DETAIL_AWALIST = 'setAwaDetailList';
export const SET_DETAIL_AWALIST_FINANCE = 'setAwaDetailListFinance';
export const SET_DETAIL_INVOICE_AWA = 'setAwaDetailInvoice';

const disburse_status = {
  WAITING_APPROVAL: {
    label: 'Waiting Approval',
    color: 'tag-warning',
  },
  WAITING_DISBURSEMENT: {
    label: 'Waiting Disbursement',
    color: 'tag-brand',
  },
  REJECTED: {
    label: 'Rejected',
    color: 'tag-danger',
  },
  COMPLETED: {
    label: 'Completed',
    color: 'tag-success',
  },
  APPROVED: {
    label: 'Approved',
    color: 'tag-success',
  },
  FAILED: {
    label: 'Failed',
    color: 'tag-danger',
  },
  CANCELLED: {
    label: 'Cancelled',
    color: 'tag-danger',
  },
};

const status = {
  WAITING_PAYMENT: {
    label: 'Waiting Payment',
    color: 'tag-warning',
  },
  WAITING_APPROVAL: {
    label: 'Waiting Approval',
    color: 'tag-warning',
  },
  OVERDUE: {
    label: 'Overdue',
    color: 'tag-danger',
  },
  CANCELLED: {
    label: 'Cancelled',
    color: 'tag-danger',
  },
  FULLY_PAID: {
    label: 'Paid',
    color: 'tag-success',
  },
  PARTIALLY_PAID: {
    label: 'Partially Paid',
    color: 'tag-warning',
  },
  APPROVED: {
    label: 'Approved',
    color: 'tag-success',
  },
  REJECTED: {
    label: 'Rejected',
    color: 'tag-danger',
  },
  FAILED: {
    label: 'Failed',
    color: 'tag-danger',
  },
  COMPLETED: {
    label: 'Completed',
    color: 'tag-success',
  },
};

const invoice_status = {
  WAITING_APPROVAL: {
    label: 'Waiting Approval',
    color: 'tag-warning',
  },
  WAITING_PAYMENT: {
    label: 'Waiting Payment',
    color: 'tag-warning',
  },
  OVERDUE: {
    label: 'Overdue',
    color: 'tag-danger',
  },
  CANCELLED: {
    label: 'Cancelled',
    color: 'tag-danger',
  },
  FULLY_PAID: {
    label: 'Paid',
    color: 'tag-success',
  },
  PARTIALLY_PAID: {
    label: 'Partially Paid',
    color: 'tag-warning',
  },
  APPROVED: {
    label: 'Approved',
    color: 'tag-success',
  },
  COMPLETED: {
    label: 'Completed',
    color: 'tag-success',
  },
};

const state = {
  awa_list: {},
  awa_list_finance: {},
  detail_awa_list: {},
  detail_invoice_awa: {},
  detail_awa_list_finance: {}
};

const getters = {
  detail_awa_list_finance(state) {
    return state.detail_awa_list_finance;
  },
  awa_list_finance(state) {
    return state.awa_list_finance;
  },
  awa_list(state) {
    return state.awa_list;
  },
  detail_awa_list(state) {
    return state.detail_awa_list;
  },
  detail_invoice_awa(state) {
    return state.detail_invoice_awa;
  },
};

const actions = {
  [GET_AWALIST_FINANCE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('/api/awa/internal/summary', param)
        .then(async ({ data }) => {
          await context.commit(SET_AWALIST_FINANCE, data.data);
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  }, 
  [GET_DETAIL_AWALIST_FINANCE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/awa/internal/summary/${param.id}/detail`, param.query)
        .then(async ({ data }) => {
          if (param.query.action !== 'download') await context.commit(SET_DETAIL_AWALIST_FINANCE, data.data);
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [INQUIRY_APPROVAL](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post(`api/awa/internal/approval/inquiry/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [SUBMIT_APPROVAL](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post(`api/awa/internal/approval/submit/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data.data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [ROLLBACK_APPROVAL](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/awa/internal/approval/rollback/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [REJECT_AWA](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/awa/internal/approval/reject/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  // need
  [INVOICE_LIST](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/awa/invoice/list/${param.id}`, param.query)
        .then(async ({ data }) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [INVOICE_GENERATE](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post(`api/awa/invoice/create/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  // [INVOICE_REGENERATE](context, param) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.post(`api/awa/${param.id}/invoice/regenerate`, param.data)
  //       .then(async ({ data }) => {
  //         resolve(data);
  //       }).catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  // [SETTLE_OVER_DUE_INVOICE](context, param) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.post(`api/awa/${param.id}/invoice/regenerate/overdue/fix`, param.data)
  //       .then(async ({ data }) => {
  //         resolve(data);
  //       }).catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  [INVOICE_INQUIRY](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.post(`api/awa/invoice/inquiry/${param.id}`, param.data)
        .then(async ({ data }) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [INVOICE_DETAIL_AWA](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/awa/invoice/detail/${param.id}/${param.invoice_id}`, param.query)
        .then(async ({ data }) => {
          await context.commit(SET_DETAIL_INVOICE_AWA, data.data);
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [INVOICE_UPDATE_STATUS](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`api/awa/invoice/status/${param.company_id}`, param.data)
      .then(async ({ data }) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  // [INVOICE_PARTIAL_UPDATE_STATUS](context, param) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.patch(`api/awa/${param.company_id}/invoice`, param.data)
  //       .then(async ({ data }) => {
  //         resolve(data);
  //       }).catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  // [CHECK_EWA_BALANCE](context, param) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.get('api/awa-wallet-balance', param)
  //       .then(async ({ data }) => {
  //         resolve(data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  // [GET_EWA_WALLET_HISTORIES](context, param) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.get('api/awa-wallet-balance/histories', param.query)
  //       .then(async ({ data }) => {
  //         resolve(data.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  // [DOWNLOAD_EWA_WALLET_HISTORIES](context, param) {
  //   return new Promise((resolve, reject) => {
  //     ApiService.get('api/awa-wallet-balance/histories/download', param.query)
  //       .then(async (response) => {
  //         resolve(response);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // },
  [GET_AWA_REPORT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/awa/internal/report', param)
        .then(async (response) => {
          resolve(response);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [GET_ALL_DETAIL_AWALIST](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/awa/internal/list', param.query)
        .then(async ({ data }) => {
          if (param.query.action !== 'download') await context.commit(SET_DETAIL_AWALIST, data.data);
          resolve(data);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  [GET_DETAIL_AWA_INSTALLMENT](context, param) {
    return new Promise((resolve, reject) => {
      ApiService.get(`api/awa/internal/${param.company_id}/${param.id}/detail?detail=true`) 
      .then(async (response) => {         
         resolve(response);
        }).catch((err) => {
          reject(err);
        });
    });
  },
};

const mutations = {
  [SET_AWALIST](state, data) {
    if (data.count) {
      data.rows = data.rows.map((v) => {
        // v.company_name = v.company.name;
        v.total_amount_str = `Rp.${v.request_amount.toLocaleString()}`;
        v.total_admin_fee_str = `Rp.${v.total_admin_fee.toLocaleString()}`;
        v.disburse_amount_str = `Rp.${v.disburse_amount.toLocaleString()}`;
        v.total_disburse_amount_str = `Rp.${v.total_disburse_amount.toLocaleString()}`;
        v.total_upfront_fee_str = `Rp.${v.total_upfront_fee.toLocaleString()}`;
        return v;
      });
    } else {
      data.count = 0;
      data.rows = [];
    }
    state.awa_list = data;
  },
  [SET_AWALIST_FINANCE](state, data) {
    if (data?.data?.count) {
      data.data.companies = data.data.companies.map((v, idx) => {
        const disburseAmount = v.total_disburse_amount;
        const transformed = {
          ...v,
          company_name: v.company?.name || '-',
          total_amount_str: `Rp.${v.total_amount?.toLocaleString() || '0'}`,
          total_admin_fee_str: `Rp.${v.total_admin_fee?.toLocaleString() || '0'}`,
          disburse_amount_str: `Rp.${v.total_disburse_amount?.toLocaleString() || '0'}`,
          total_upfront_fee_str: `Rp.${v.total_upfront_fee?.toLocaleString() || '0'}`
        };
        return transformed;
      });
    } else {
      data.data.count = 0;
      data.data.companies = [];
    }  
    state.awa_list_finance = data;
  },
  [SET_DETAIL_AWALIST_FINANCE](state, data) {
    if (!data.count) {
      state.detail_awa_list_finance = {
        count: 0,
        rows: [],
      };
      return;
    }
    data.rows = data.rows.map((v) => {
      v.company_name = v.company?.company_name || '-';
      v.request_amount_str = `Rp.${v.request_amount?.toLocaleString() || '-'}`;
      v.processing_fee_str = `Rp.${v.processing_fee?.toLocaleString() || '-'}`;
      v.admin_fee_str = `Rp.${v.admin_fee?.toLocaleString() || '-'}`;
      v.requestor_name = v.requestor?.full_name || '-';
      v.requestor_phone_number = v.requestor?.phone_number || '-';
      v.status_str = status[v.status]?.label || '-';
      v.status_color = status[v.status]?.color || 'default-color';
      if (v.status === 'rejected') {
        v.disburse_status_str = '-';
        v.disburse_status_color = 'tag-default';
      } else {
        v.disburse_status_str = disburse_status[v.disburse_status]?.label || '-';
        v.disburse_status_color = disburse_status[v.disburse_status]?.color || 'default-color';
      }
      v.created_at_str = v.created_at ? moment(v.created_at).format('DD MMM YYYY, HH:mm') : '-';
      v.approved_at_str = v.approved_at ? moment(v.approved_at).format('DD MMM YYYY, HH:mm') : '-';
      v.duedate_at_str = v.due_date ? moment(v.due_date).format('DD MMM YYYY, HH:mm') : '-';
      v.approved_at_str = v.approved_at ? moment(v.approved_at).format('DD MMM YYYY, HH:mm') : '-';
      v.rejected_at_str = v.rejected_at ? moment(v.rejected_at).format('DD MMM YYYY, HH:mm') : '-';
      v.disburse_at_str = v.disburse_at ? moment(v.disburse_at).format('DD MMM YYYY, HH:mm') : '-';
      return v;
    });
    state.detail_awa_list_finance = data;
  },
  [SET_DETAIL_AWALIST](state, data) {
    if (!data.count) {
      state.detail_awa_list = {
        count: 0,
        rows: [],
      };
      return;
    }
    data.rows = data.rows.map((v) => {
      v.company_name = v.company?.company_name || '-';
      v.request_amount_str = `Rp.${v.request_amount?.toLocaleString() || '-'}`;
      v.processing_fee_str = `Rp.${v.processing_fee?.toLocaleString() || '-'}`;
      v.admin_fee_str = `Rp.${v.admin_fee?.toLocaleString() || '-'}`;
      v.insurance_fee_str = `Rp.${v.insurance_fee?.toLocaleString() || '-'}`;
      v.processing_fee_str = `Rp.${v.processing_fee?.toLocaleString() || '-'}`;
      v.requestor_name = v.requestor?.full_name || '-';
      v.requestor_phone_number = v.requestor?.phone_number || '-';
      v.status_str = status[v.status]?.label || '-';
      v.status_color = status[v.status]?.color || 'default-color';
      if (v.disburse_status === 'REJECTED') {
        v.disburse_status_str = '-';
        v.disburse_status_color = 'tag-default';
      } else {
        v.disburse_status_str = disburse_status[v.disburse_status]?.label || '-';
        v.disburse_status_color = disburse_status[v.disburse_status]?.color || 'default-color';
      }
      v.created_at_str = v.created_at ? moment(v.created_at).format('DD MMM YYYY, HH:mm') : '-';
      v.duedate_at_str = v.due_date ? moment(v.due_date).format('DD MMM YYYY, HH:mm') : '-';
      v.approved_at_str = v.approved_at ? moment(v.approved_at).format('DD MMM YYYY, HH:mm') : '-';
      v.rejected_at_str = v.rejected_at ? moment(v.rejected_at).format('DD MMM YYYY, HH:mm') : '-';
      v.disburse_at_str = v.disburse_at ? moment(v.disburse_at).format('DD MMM YYYY, HH:mm') : '-';
      return v;
    });
    state.detail_awa_list = data;
  },
  [SET_DETAIL_INVOICE_AWA](state, data) {
    if (!data.count) {
      state.detail_invoice_awa = {
        count: 0,
        rows: [],
      };
      return;
    }
    data.rows = data.rows.map((v) => {
      ['created_at', 'paid_at'].forEach((k) => {
        v[`${k}_str`] = !v[k] ? '-' : moment(v[k]).format('DD MMM YYYY, HH:mm');
      });
      v.invoice_number = v.awa_invoice.invoice_number;
      v.amount_str = `Rp. ${v.amount.toLocaleString()}`;
      v.status_str = invoice_status[v.status]?.label || '-';
      v.status_color = invoice_status[v.status]?.color || 'default-color';
      v.requestor_name = v.awa.requestor.full_name;
      v.request_amount_str = `Rp.${v.amount.toLocaleString()}`;
      v.processing_fee_str = `Rp.${v.processing_fee?.toLocaleString()}`;
      v.principal_amount_str = `Rp.${v.principal_amount.toLocaleString()}`;
      v.interest_amount_str = `Rp.${v.interest_amount.toLocaleString()}`;
      v.admin_fee_str = `Rp.${v.awa.admin_fee.toLocaleString()}`;
      v.disburse_at_str = moment(v.awa.disburse_at).format('DD MMM YYYY, HH:mm');
      return v;
    });
    state.detail_invoice_awa = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};